<template>
  <div>
    <el-row>
      <el-col :md="24" :sm="24">
        <el-card shadow="never">
          <div slot="header">
            <span style="font-size: 20px"> 欢迎您~~~{{userInfo.fullName}}, 欢迎使用上刊选点系统！</span>
          </div>
          <div ref="myChart" style="width:100%; height:600px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/WorkPlace.vue